import { useAdaptable } from '../AdaptableContext';
export const useGridFilterOptionsForExpressionEditorProps = () => {
    const adaptable = useAdaptable();
    const gridFilterEditors = adaptable.api.optionsApi.getGridFilterOptions().availableFilterEditors;
    return {
        showQueryBuilder: gridFilterEditors.includes('QueryBuilder'),
        showExpressionEditor: gridFilterEditors.includes('ExpressionEditor'),
    };
};
